import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from 'comps/tooltip';

import Star from './star';

const Row = styled.div`
  margin: 2px;
`;

const MAX_RATING = 5;

function getValue(idx, value) {
  if (idx <= value) return 100;

  if (idx === Math.ceil(value)) return Math.ceil((value * 100) % 100);

  return 0;
}

const Rating = ({ value }) => {
  return (
    <Row>
      {Array.from(Array(MAX_RATING).keys()).map(i => (
        <Star key={i} value={getValue(i + 1, value)} id={i + 1} />
      ))}
    </Row>
  );
};

Rating.propTypes = {
  value: PropTypes.number.isRequired,
};

export default Rating;
